import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from '@/mixins/infoList';
import { getCurrencyList, getMerchantOrderList, getOperationStatusList } from '@/api/merchantOrder';
export default {
  name: 'Balance',
  mixins: [infoList],
  data: function data() {
    return {
      zeroTime: null,
      currentTime: null,
      currency: '',
      listApi: getMerchantOrderList,
      currencyList: [],
      statusList: {},
      status: ''
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchInfo.StartTime = -1;
            _this.searchInfo.EndTime = -1;
            _this.searchInfo.OrderType = 2;
            _this.searchInfo.CurrencyType = -1;
            _this.searchInfo.Status = -2;
            _this.getCurrency();
            _this.getStatusList();
            _context.next = 1;
            return _this.getTableData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getCurrency: function getCurrency() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getCurrencyList();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.currencyList = res.data;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getStatusList: function getStatusList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getOperationStatusList();
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.statusList = res.data;
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};